import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { orgShowStatus } from "../../../../service/endpoints";

export const dashboardStatusHandler = createAsyncThunk('dashboardStatusHandler', async () => {
    try {
        const response = await orgShowStatus()
        console.log(response.data,'classroom')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
    })


const DashboardStatusSlice = createSlice({
    name: 'get_stautus',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardStatusHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(dashboardStatusHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(dashboardStatusHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        });
    }

})

export default DashboardStatusSlice.reducer;